import { fecthGet, fecthPost, fecthDelete } from '@/hotelcem/apis/request'

export default {
  /**
   * 上报统计数据
   */
  hotelPV(params) {
    return fecthPost('/data-source/hotel/analysis/pv', params)
  },
}
